import api from '../../utils/axios';

export const enquiryService = {
    // Get all enquiries for the logged-in agent
    getEnquiries: async (params = {}) => {
        const response = await api.get('/enquiries', { params });
        return response.data;
    },

    // Update enquiry status
    updateStatus: async (id, status) => {
        const response = await api.patch(`/enquiries/${id}/status`, { status });
        return response.data;
    },

    // Export enquiries as CSV
    exportCSV: async (params = {}) => {
        const response = await api.get('/enquiries/export', {
            params,
            responseType: 'blob'
        });
        return response.data;
    },

    // Delete enquiry
    deleteEnquiry: async (id) => {
        const response = await api.delete(`/enquiries/${id}`);
        return response.data;
    }
};
